export enum QUERY_KEY {
  addFavoritePlace = 'addFavoritePlace',
  createBikeShelterAccess = 'createBikeShelterAccess',
  createCard = 'createCard',
  createClaim = 'createClaim',
  createProofOfPurchase = 'createProofOfPurchase',
  deleteAccount = 'deleteAccount',
  deleteBikeShelterAccess = 'deleteBikeShelterAccess',
  deleteFavoritePlace = 'deleteFavoritePlace',
  deletePaymentCard = 'deletePaymentCard',
  featuresStates = 'featuresStates',
  finalizeResume = 'finalizeResume',
  getBookExchange = 'getBookExchange',
  getBikeSheltersAccess = 'getBikeSheltersAccess',
  getBikeSheltersForm = 'getBikeSheltersForm',
  getCards = 'getCards',
  getCart = 'getCart',
  getCatalogOffers = 'getCatalogOffers',
  getCatalogOfferWishes = 'getCatalogOfferWishes',
  getCatalogProductAutocomplete = 'getCatalogProductAutocomplete',
  getCountries = 'getCountries',
  getCrc = 'getCrc',
  getDisruptionsCount = 'getDisruptionsCount',
  getFavoritePlaces = 'getFavoritePlaces',
  getFinalization = 'getFinalization',
  getGoogleWallet = 'getGoogleWallet',
  getNetworkTrafficInfo = 'getNetworkTrafficInfo',
  getNotificationSubscriptions = 'getNotificationSubscriptions',
  getPaymentCards = 'getPaymentCards',
  getStationTimetableState = 'getStationTimetableState',
  getTicketDetail = 'getTicketDetail',
  getTickets = 'getTickets',
  getPastTickets = 'getPastTickets',
  getTrafficInfo = 'getTrafficInfo',
  searchAutocomplete = 'search-autocomplete',
  searchAutocompleteSuggestions = 'search-autocomplete-suggestions',
  trip = 'trip',
  tripList = 'trip-list',
  tripPass = 'tripPass',
  updateFavoritePlace = 'updateFavoritePlace',
  updateNotificationSubscription = 'updateNotificationSubscription',
  updateTheme = 'updateTheme',
  vehicleDetails = 'vehicleDetails',
}
